<template>
  <div class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Mono Memory</h2>
    </div>

    <div class="part__cnt">
      <div class="label_style mt-3">
        <ul>
          <li>Max(Mono Memory)[M]</li>
          <li>{{ testInfo?.max_mono_total }}</li>
        </ul>
        <ul>
          <li>Max(Mono Memory Used)[M]</li>
          <li>{{ testInfo?.max_mono_used }}</li>
        </ul>
      </div>

      <div v-show="chartHasData" class="position-relative">
        <div id="mono_line" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="mono_line_chart" />
        <chart-rect ref="chartRect1" chartKey="mono_line_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

const useCharts = {
  props: {
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    chartDataMonoMem() {
      return this.perf_second_data?.['Mono使用率']
    },

    chartHasData() {
      const {mono_total, mono_used} = this.chartDataMonoMem.rows
      if (mono_total?.length || mono_used?.length) return true
      else return false
    },
  },

  methods: {
    getOption() {
      return {
        title: {
          text: "MONO堆内存趋势",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataMonoMem?.rows?.timeline,
        },
        series: [
          {
            name: "mono_total",
            type: "line",
            showSymbol: false,
            data: this.chartDataMonoMem.rows.mono_total,
          },
          {
            name: "mono_used",
            type: "line",
            showSymbol: false,
            data: this.chartDataMonoMem.rows.mono_used,
          },
        ],
      }
    },

    drawPieChartMono() {
      let chartDom = document.getElementById("mono_line")
      if (!chartDom) return
      if (!allChart.mono_line_chart) {
        allChart.mono_line_chart = echarts.init(chartDom)
      }
      allChart.mono_line_chart.setOption(this.getOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useCharts],

  inject: ['injectObj'],

  props: {
    testInfo: Object,
  },

  data() {
    return {
      
    }
  },

  computed: {
    project() {
      return this.$route.query.project
    },
  },

  methods: {
    async init(isMounted) {
      this.drawPieChartMono()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>